module.exports = __webpack_public_path__ + "img/appAsset-brand--sat.1a3d7e64.svg";